import { render } from "./LifecycleHooks.vue?vue&type=template&id=016a6482"
import script from "./LifecycleHooks.vue?vue&type=script&lang=js"
export * from "./LifecycleHooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__